"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ProductRecommendationFragment_1 = __importDefault(require("../fragments/ProductRecommendationFragment"));
const AdsShowcaseQuery = (0, graphql_tag_1.default) `
  query adsShowcaseQuery(
    $metadata: MetadataInput!
    $products: [AdsProductInput!]
    $zipcode: String
    $omitProductIds: [String!]
  ) {
    ads(
      input: {
        metadata: $metadata
        products: $products
        zipcode: $zipcode
        omitProductIds: $omitProductIds
      }
    ) {
      products {
        trackId
        campaignId
        slot
        product {
          ...product
        }
      }
    }
  }
  ${ProductRecommendationFragment_1.default}
`;
exports.default = AdsShowcaseQuery;
